// S26 知識缺口 /ai/kb-gaps — no_answer 問題彙集(唯讀)。
//
// 彙集 reply.status='no_answer' 的問句(依出現次數多到少),供內容團隊補知識庫。
// 文件編輯本身留 cs 自有台;此頁只唯讀呈現缺口。

import { useCallback, useEffect, useState } from 'react';
import { EmptyState, ErrorState, LoadingState } from '../../components/StateBlock';
import { fetchKbGaps, formatCsTime } from './aiOpsApi';
import type { AiKbGap } from './aiOpsApi';
import '../../features/_shared/shared.css';
import './aiOps.css';

export default function KbGapsPage() {
  const [gaps, setGaps] = useState<AiKbGap[] | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback((signal?: AbortSignal) => {
    setLoading(true);
    setError(null);
    fetchKbGaps(signal)
      .then((r) => setGaps(r.gaps))
      .catch((e) => {
        if (!signal?.aborted) {
          setError(e);
          setGaps(null);
        }
      })
      .finally(() => {
        if (!signal?.aborted) setLoading(false);
      });
  }, []);

  useEffect(() => {
    const ac = new AbortController();
    load(ac.signal);
    return () => ac.abort();
  }, [load]);

  const showInitialLoading = loading && gaps === null;

  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-title">知識缺口</h1>
          <p className="page-subtitle">
            客服查無知識而轉人工(no_answer)的問句彙集,依重複次數排序 —— 補齊知識庫的優先線索。唯讀;文件編輯請至 cs 知識庫台。
          </p>
        </div>
        <button className="btn-ghost" onClick={() => load()} disabled={loading}>
          {loading ? '載入中…' : '重新整理'}
        </button>
      </div>

      {showInitialLoading && <LoadingState label="載入知識缺口…" />}
      {error != null && gaps === null && <ErrorState error={error} onRetry={() => load()} />}

      {gaps && gaps.length === 0 && <EmptyState title="沒有知識缺口" detail="目前沒有 no_answer 的問句彙集,知識庫覆蓋良好。" />}

      {gaps && gaps.length > 0 && (
        <div className="table-wrap" data-testid="kb-gaps-table">
          <table className="data-table">
            <thead>
              <tr>
                <th>問句</th>
                <th style={{ width: '8ch' }}>次數</th>
                <th style={{ width: '20ch' }}>最近一次</th>
              </tr>
            </thead>
            <tbody>
              {gaps.map((g, i) => (
                <tr key={i}>
                  <td className="adm-cell-strong">{g.query || '—'}</td>
                  <td>
                    <span className="aiops-gap-count">{g.count}</span>
                  </td>
                  <td className="adm-mono">{formatCsTime(g.last)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="adm-pager">
            <span className="text-secondary">共 {gaps.length} 筆</span>
          </div>
        </div>
      )}
    </>
  );
}
